import axios from 'axios'

// TODO : gérer les erreurs proprement
const errorHandler = error => {
  if (error) {
    console.log('Error', error)
  }
  return Promise.reject(error)
}

export const init = () => {
  return axios.get('/api/v1/init')
    .then(response => response.data)
    .catch(errorHandler)
}

export const login = (payload) => {
  return axios.post('/api/v1/login', payload)
    .then(response => response.data)
    .catch(errorHandler)
}

export const logout = () => {
  return axios.post('/api/v1/logout')
    .then(response => response.data)
    .catch(errorHandler)
}

export const register = (payload) => {
  return axios.post('/api/v1/register', payload)
    .then(response => response.data)
    .catch(errorHandler)
}

export const askReset = (payload, option) => {
  return axios.post('/api/v1/recoverPassword/' + option, payload)
    .then(response => response.data)
    .catch(errorHandler)
}

export const changePassword = (payload) => {
  return axios.post('/api/v1/recoveryreset', payload)
    .then(response => response.data)
    .catch(errorHandler)
};


export const execValidate = (token) => {
  return axios.post(`/api/v1/validate`, { token })
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadValidateUsers = () => {
  return axios.get('/api/v1/users')
    .then(response => response.data)
    .catch(errorHandler)
}

export const execDeclineUsers = (motif, idUser, dateactivation) => {
  return axios.post(`/api/v1/users/${idUser}/decline`, { motif, dateactivation })
    .then(response => response.data)
    .catch(errorHandler)
}

export const execActivateUsers = (idUser, dateactivation) => {
  return axios.post(`/api/v1/users/${idUser}/activate`, { dateactivation })
    .then(response => response.data)
    .catch(errorHandler)
}

export const updateUserData = (payload, idUser) => {
  return axios.post(`/api/v1/users/${idUser}`, payload)
    .then(response => response.data)
    .catch(errorHandler)
}

export const updateUserRole = (idUser, role) => {
  return axios.post(`/api/v1/users/${idUser}/role`, { role })
    .then(response => response.data)
    .catch(errorHandler)
}

export const updateUserActif = (idUser, actif) => {
  return axios.post(`/api/v1/users/${idUser}/actif`, { actif })
    .then(response => response.data)
    .catch(errorHandler)
}
export const updateUserSimuClim = (idUser, simuClim) => {
  return axios.post(`/api/v1/users/${idUser}/simu_clim`, { simu_clim: simuClim })
    .then(response => response.data)
    .catch(errorHandler)
}

export const execCountUsers = () => {
  return axios.get(`/api/v1/countInscription`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** EXPLOITATION ******/

export const loadExploitations = () => {
  return axios.get('/api/v1/exploitations')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadExploitation = (idExploitation) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const createExploitation = (nom) => {
  return axios.post('/api/v1/exploitations', { nom })
    .then(response => response.data)
    .catch(errorHandler)
}

export const duplicateExploitation = (idExploitation, nom, idSimulations) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/duplicate`, { nom, idSimulations })
    .then(response => response.data)
    .catch(errorHandler)
}

export const deleteExploitation = (idExploitation) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const saveExploitation = (idExploitation, data) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}`, data)
    .then(response => response.data.information)
    .catch(errorHandler)
}

export const addExploitant = (idExploitation, data) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/exploitant`, data)
    .then(response => response.data.information)
    .catch(errorHandler)
}

export const updateExploitant = (idExploitation, idUser, data) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}/exploitant/${idUser}`, data)
    .then(response => response.data.information)
    .catch(errorHandler)
}

export const loadAnneesSeches = (idExploitation) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/anneesseches`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadSimuClim = (idExploitation) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simuclim`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** CULTURE ******/

export const createCulture = (idExploitation, idRefCulture) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/cultures`, { id_ref_culture: idRefCulture })
    .then(response => response.data)
    .catch(errorHandler)
}

export const updateCulture = (idExploitation, idCulture, data) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}/cultures/${idCulture}`, data)
    .then(response => response.data)
    .catch(errorHandler)
}
export const removeCulture = (idExploitation, idCulture) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}/cultures/${idCulture}`)
    .then(response => response.data)
    .catch(errorHandler)
}
export const duplicateCulture = (idExploitation, idCulture) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/cultures/${idCulture}/duplicate`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** ILOT ******/

export const createIlot = (idExploitation, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/ilots`, { nom })
    .then(response => response.data.ilot)
    .catch(errorHandler)
}

export const updateIlot = (idExploitation, idIlot, data) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}/ilots/${idIlot}`, data)
    .then(response => response.data)
    .catch(errorHandler)
}
export const removeIlot = (idExploitation, idIlot) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}/ilots/${idIlot}`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** SIMULATION ******/

export const getSimulations = (idExploitation) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations`)
    .then(response => response.data.simulations)
    .catch(errorHandler)
}

export const createSimulation = (idExploitation, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations`, { nom })
    .then(response => response.data.simulation)
    .catch(errorHandler)
}

export const duplicateSimulation = (idExploitation, idSimulation, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/duplicate`, { nom })
    .then(response => response.data.simulation)
    .catch(errorHandler)
}

export const renameSimulation = (idExploitation, idSimulation, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/rename`, { nom })
    .then(response => response.data.simulation)
    .catch(errorHandler)
}

export const removeSimulation = (idExploitation, idSimulation) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadSimulation = (idExploitation, idSimulation) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const saveParcelles = (idExploitation, idSimulation, idIlot, parcelles) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/${idIlot}`, { parcelles })
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadResultByIlot = (idExploitation, idSimulation, idIlot, annees) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/resultatByIlot`, { params: { idIlot, annees } })
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadResultByCulture = (idExploitation, idSimulation, idIlot, annees) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/resultatByCulture`, { params: { idIlot, annees } })
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadResultForGraph = (idExploitation, idSimulation, type, idIlot, idCulture, annees) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/statistique`, { params: { type, annees, idIlot, idCulture } })
    .then(response => response.data)
    .catch(errorHandler)
}

export const getExportCSV = (idExploitation, idSimulation, idIlot, annees, type) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/getExportCSV/${type}`, { params: { idIlot, annees } })
    .then(response => response.data)
    .catch(errorHandler)
}

export const updateSynthese = (idExploitation, idSimulation, simulationInfo) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/synthese`, simulationInfo)
    .then(response => response.data)
    .catch(errorHandler)
}

export const calculAgro = (idExploitation, idSimulation, idScenario) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/${idScenario}/calcul_agro`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const calculEco = (idExploitation, idSimulation, idScenario) => {
  return axios.get(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/${idScenario}/calcul_eco`)
    .then(response => response.data)
    .catch(errorHandler)
}

export const removeIlotData = (idExploitation, idSimulation, idIlot) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/remove/${idIlot}`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** SCENARIO ******/

export const createScenario = (idExploitation, idSimulation, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/scenarios`, { nom })
    .then(response => response.data.scenario)
    .catch(errorHandler)
}

export const updateScenario = (idExploitation, idSimulation, idScenario, nom) => {
  return axios.put(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/scenarios/${idScenario}`, { nom })
    .then(response => response.data.scenario)
    .catch(errorHandler)
}

export const duplicateScenario = (idExploitation, idSimulation, idScenario, nom) => {
  return axios.post(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/scenarios/${idScenario}/duplicate`, { nom })
    .then(response => response.data.scenario)
    .catch(errorHandler)
}

export const removeScenario = (idExploitation, idSimulation, idScenario) => {
  return axios.delete(`/api/v1/exploitations/${idExploitation}/simulations/${idSimulation}/scenarios/${idScenario}`)
    .then(response => response.data)
    .catch(errorHandler)
}

/** **** REFERENTIEL ******/

export const loadTypeSol = () => {
  return axios.get('/api/v1/referentiels/typesol')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadCulture = () => {
  return axios.get('/api/v1/referentiels/culture')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadCulturePrec = () => {
  return axios.get('/api/v1/referentiels/culture_prec')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadTypeMateriel = () => {
  return axios.get('/api/v1/referentiels/typemateriel')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadStade = () => {
  return axios.get('/api/v1/referentiels/stade')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadCultureStade = () => {
  return axios.get('/api/v1/referentiels/culturestade')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadVariete = () => {
  return axios.get('/api/v1/referentiels/variete')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadAgence = () => {
  return axios.get('/api/v1/referentiels/agence')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadTypeSource = () => {
  return axios.get('/api/v1/referentiels/source')
    .then(response => response.data)
    .catch(errorHandler)
}

export const loadPrixEau = () => {
  return axios.get('/api/v1/referentiels/prixeau')
    .then(response => response.data)
    .catch(errorHandler)
}

export const searchCommune = (search) => {
  return axios.get(`/api/v1/referentiels/commune`, { params: { q: search } })
    .then(response => response.data)
    .catch(errorHandler)
}
